import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router'

import { compose } from 'shared/helpers';
import { userWillLogout } from 'shared/actions/session';
import { newNotification } from 'shared/actions/view/web';

import { cx } from 'helpers';
import {
  Menu,
  FontIcon,  // TODO: Maybe try getting rid of FontIcon?
  Image,
  Popover,
  popWithMotion,
} from 'components/elems';
import { withNotify } from 'components/hocs';


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    userWillLogout,
    newNotification,
  }, dispatch);
}


// TODO(tyu): Need to replace with profile pic
const userImageOrIconSize = 22;


const UserAvatar = () => (
  <div className={cx("flex items-center black-40 pointer")}>
    {Math.round(Math.random() * 100) % 2 ? (
      <Image
        className="mr1 br2"
        width={userImageOrIconSize}
        src="https://pbs.twimg.com/profile_images/658682154570924036/PXrltjrg_400x400.jpg"
      />
    ) : (
      <div
        style={{
          width: `${userImageOrIconSize}px`,
          height: `${userImageOrIconSize}px`,
        }}
        className={cx(
          "flex items-center justify-center mr1 ba b--black-40 br2"
        )}
      >
        <FontIcon className="black-40" type="user" />
      </div>
    )}
  </div>
);



class CurrentEntityOptionDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isVisible: false };

    this.handleLogoutAction = this.handleLogoutAction.bind(this);
  }

  handleLogoutAction(e) {
    // First dispatch an action to handle jwt.
    this.props.userWillLogout();
    // `history` passed down via withRouter HOC, used to redirect.
    // Reference: https://stackoverflow.com/a/44533227/3479934
    this.props.history.push('/login');
    this.props.notifySuccess("You are logged out.");
  }

  render() {
    return (
      <Popover placement="bottom-end">
        <UserAvatar />

        {popWithMotion(
          <Menu>
            <Menu.Row link="/settings">
              <span>Settings</span>
            </Menu.Row>

            <Menu.Divider />

            <Menu.Row href="mailto:hello@moagraph.com">
              <span>Help</span>
            </Menu.Row>

            <Menu.Row onClick={this.handleLogoutAction}>
              <span>Logout</span>
            </Menu.Row>
          </Menu>,

          { fromPosY: -10 }
        )}
      </Popover>
    );
  }
}


export default compose(
  connect(null, mapDispatchToProps),
  withRouter,
  withNotify,
)(CurrentEntityOptionDropdown);



// WEBPACK FOOTER //
// ./src/components/navs/_navbar/CurrentEntityOptionDropdown.js